import { Clock, ShieldCheck, CheckCircle2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { fmtDate } from "@/lib/format";
import { ContinueActions } from "@/components/company/ContinueActions";

const daysText = (left) => (left <= 1 ? "Oggi è l'ultimo giorno di prova" : `Mancano ${left} giorni alla fine della prova`);

export default function Abbonamento() {
  const { user } = useAuth();
  const company = user?.company || {};
  const trial = company.plan === "trial";
  return (
    <div className="max-w-xl mx-auto space-y-6 animate-in-up" data-testid="abbonamento-page">
      <div className="rounded-2xl border border-border bg-card p-6 sm:p-8 space-y-5 text-center">
        {trial ? (
          <>
            <div className="w-12 h-12 rounded-full bg-primary/10 text-primary flex items-center justify-center mx-auto"><Clock className="w-6 h-6" /></div>
            <div>
              <h1 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight" data-testid="abbonamento-title">{daysText(company.trial_days_left)}</h1>
              <p className="text-sm text-muted-foreground mt-2">La prova gratuita di <b className="text-foreground">{company.ragione_sociale}</b> termina il {fmtDate(company.trial_ends_at)}. Continua per non perdere l'accesso.</p>
            </div>
            <ContinueActions company={company} isAdmin={user?.role === "admin"} />
            <div className="rounded-xl bg-secondary/60 p-3 text-xs text-muted-foreground flex items-center gap-2 text-left">
              <ShieldCheck className="w-4 h-4 text-emerald-600 shrink-0" /> I tuoi dati restano salvati in ogni caso.
            </div>
          </>
        ) : (
          <>
            <CheckCircle2 className="w-12 h-12 text-emerald-600 mx-auto" />
            <h1 className="font-heading text-2xl font-extrabold" data-testid="abbonamento-title">Il tuo account è attivo</h1>
            <p className="text-sm text-muted-foreground">Puoi usare K Gestionale senza scadenza.</p>
          </>
        )}
      </div>
    </div>
  );
}
